import { AfterViewInit, ChangeDetectorRef, Component, ComponentRef, ElementRef, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { WizBooleanUtils, WizDateUtils, WIZ_EVENT_TYPE, WIZ_UPLOAD_ACCEPT_FORMAT, VALUE_ENTER, CODE_SPACE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  WizCheckbox,
  WizDateField,
  WizHgroup,
  WizImage,
  WizLabel,
  WizNumericInput,
  WizTextarea,
  WizTextInput,
  WizValidationContainerDirective,
  WizValidationError,
  WizValidationErrors,
  WizValidatorFn,
  WizButton,
  WizEvent, WizEventManager,
  WizGroup,
  WizIcon,
  UploadParameter,
  ImageUploadParameter,
  WizPopUp,
  WizVgroup,
  WizRoot,
  WizTranslationManager,
  WizComponentManager
} from '@wizeoo/akm-component-lib';
import { Observable, of } from 'rxjs';
import { FIELD_KIND, FeiKeyDef, MathUtils, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';
import { Attachment, Measure, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';

import { ALK_EVENT_TYPE, WIDGET_GLOBAL_KIND } from '../../../model/enums';
import { ViewData } from '../../../model/view.data';
import { Model } from '../../../model/model';
import { AlkEvent } from '../../../framework/events/alk.event';
import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { FormFieldObj } from '../../../manager/baselines/form-field.obj';
import { FormItemObj } from '../../../manager/baselines/form-item.obj';
import { IForm } from '../../../manager/widgets/i-form';
import { FreedataValueVO } from  '../../../vo/core/freedatavalue.vo';
import { ConnectVO } from '../../../vo/core/connect.vo';
import { ColorPickerPop } from '../../colorpicker/color-picker.pop';
import { AttachmentService, MediaReference } from "../../../command/core/attachment/attachment.service";
import { StyleEngine } from "../../../manager/workingdata/style.engine";
import { FormDropExtendedRenderer } from './drops/form-drop-extended.renderer';
import { FreedataArgsVO } from '../../../vo/core/freedataargs.vo';
import { AngularEditorComponent, AngularEditorConfig } from '@wfpena/angular-wysiwyg';
import { PopUtils } from '../../../framework/components/pop/pop-utils';
import { PivotCellEditPopData } from '../../../manager/widgets/i-widget';
import { zoomPopParams } from '../freedatas/renderers/zoom.pop';
import { cloneDeep } from 'lodash';
// import { FormWidget } from './form.widget'; // surtout pas, sinon cycle...

/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'form-field-renderer',
  templateUrl: './form-field.renderer.html'
})
export class FormFieldRenderer implements AfterViewInit, IWizItemRenderer<WidgetConfigurationItemObj, FormFieldObj> {

  @ViewChild('argContainer') argContainer: WizHgroup; // groupe principal, pour pose du disable sur les éléments de clés pour les WidgetLines existantes
  /** Zone de validation des champs de saisie */
  @ViewChild('argContainer', { read: WizValidationContainerDirective, static: false }) validationContainer: WizValidationContainerDirective;

  @ViewChild('ddext', { read: FormDropExtendedRenderer }) ddext: FormDropExtendedRenderer;
  // @ViewChild('dd', { read: WizDropdown }) dd: WizDropdown;
  @ViewChild('ni', { read: WizNumericInput, static: false }) ni: WizNumericInput;
  @ViewChild('ti', { read: WizTextInput, static: false }) ti: WizTextInput;
  @ViewChild('da', { read: WizDateField, static: false }) da: WizDateField;
  @ViewChild('cb', { read: WizCheckbox, static: false }) cb: WizCheckbox;
  @ViewChild('ta', { read: WizTextarea, static: false }) ta: WizTextarea;

  @ViewChild('imgGp', { read: WizHgroup, static: false }) imgGp: WizHgroup;
    @ViewChild('imgLbl', { read: WizLabel, static: false }) imgLbl: WizLabel;
    @ViewChild('img', { read: WizImage, static: false }) img: WizImage;
  
  @ViewChild('listGP', { read: WizHgroup, static: false }) listGP: WizHgroup; // rendu pour les commentaires / liste de rendu
    @ViewChild('listLbl', { read: WizLabel, static: false }) listLbl: WizLabel;

  @ViewChild('linkGp', { read: WizHgroup, static: false }) linkGp: WizHgroup; // rendu html de la baseline

  @ViewChild('bt', { read: WizButton, static: false }) bt: WizButton; // fonction connect libre

  @ViewChild('freeGrp', { read: WizHgroup, static: false }) freeGrp: WizHgroup; // rendu html libre
  @ViewChild('ae') ae: AngularEditorComponent; // free
   
  @ViewChild('freeImgGrp', { read: WizHgroup, static: false }) freeImgGrp: WizHgroup; // groupe image libre
    @ViewChild('freeImg') freeImg: WizImage; // image libre
  
  @ViewChild('seqGP', { read: WizHgroup, static: false }) seqGP: WizHgroup; // rendu pour les FDs en mode séquence
    
  @ViewChild('cellBlockBack') cellBlockBack: ElementRef; // zone de dessin de la couleur de background

  @ViewChild('dropGrp', { read: WizGroup, static: false }) dropGrp: WizGroup; // zone de drop de fichier
  @ViewChild('icoAddFile', { read: WizIcon, static: false }) icoAddFile: WizIcon; // ajout de fichier
  @ViewChild('icoDelFile', { read: WizIcon, static: false }) icoDelFile: WizIcon; // suppression du lien de fichier

  @ViewChild('workflowGroup', { read: WizVgroup, static: false }) workflowGroup: WizVgroup; // rendu hyperlink du FDV

  @ViewChild('icoList') icoList: any; // icône pour ouverture de la liste de valeurs
  @ViewChild('icoList') icoThreshold: any; // icône pour ouverture de la liste des seuils
  
  @ViewChild('gridInjector', { read: ViewContainerRef, static: false }) gridInjector: ViewContainerRef;


  public baseWidth: number = 600;
  public baseHeight: number = 130;
 
  constructor(public elementRef: ElementRef, public cdref: ChangeDetectorRef) {}
  owner: null;

  private _data: FormFieldObj; // données sources
  @Input() public set data(ffo: FormFieldObj) {
    this._data = ffo;
    this.fkd = ffo.fkd;
    this.fei = ffo.fei;
    // this.widget = ffo.widget;
  }


  public get data(): FormFieldObj {
    return this._data;
  }

  public get widget(): IForm {
    return this.data?.widget as IForm;
  }

  public get model(): Model {
    return this.widget?.model;
  }

  public fei: FeiVO; // en vrai, c'est le fake
  // public widget: IWidget; // accesseur sur le widget, NULL en mode templating
  public fkd: FeiKeyDef; // la définition de la clé. Nul dans le cas des champs libres

  // le clone de travail
  public get clone(): WidgetLine { 
    return this.widget?.clone;
  } 


  private rawValue: string = null; // valeur brute (en cours de traitement)
  public formatedValue: any = null; // la valeur formatée pour le rendu dans les composants 

  public forceCaps: string = ''; // forcer l'upperCase

  /* ##############################################################################
                  paramètres d'affichage
  ############################################################################## */

  //##### les activateurs de ngIf ######
  useddext = false; // drop (champ FD ou chrono)...
  wizmandatory: boolean = false;
  wizdisabled: boolean = false;
  checkEditDisable: boolean = false;

  useSeqGP = false; // champs FD de type séquence

  useni = false; // champs numériques
  decimal = 2;
  wizmin = null;
  wizmax = null;

  useti = false; // champs texte
  public forceRestrict = null; // restriction sur saisie de code / shortCode
  
  useta = false; // champs commentaire
  useda = false; // champs date
  usecb = false; // champs booléen
  useimgGp = false; // champs image
  usemedia = false; // champs média

  uselistGP = false; // champs liste de valeurs
  usethresholdGP = false; // champ seuil

  uselinkGp = false; // champs hyperlien
  public linkUrl: string = ''; // cas d'un rendu link, label|url
  public linkLabel: string = ''; // cas d'un rendu link, label|url

  usebt = false; // champs fonction connect
  public cnx: ConnectVO = null; // fonction connect du bouton

  usefreeGrp = false; // champs rendu libre
  readyfreeGrp = false; // prêt pour l'affichage, évite la toolbar
  
  usefreeImgGrp = false; // champs image libre
  public imgSrcObs: Observable<string> = null;
  public imgBlobid: string = null;

  usecolor = false; // champ de type color
  
  useDropGrp = false; // zone de drop de fichier
  public mediaReference: MediaReference = null;

  useworkflow = false; // rendu workflow
      public workImage: Observable<string> = of(null); // image liée
      public workImageBlob: string = null;
      public workIcon: string = null; // l'icone du statut si utilisée
      public workflowLabel: string = null; // le libellé du workflow
      public workFile:  MediaReference = null; // pièce jointe

  usefreeZone = false; // rendu container
  public freezoneHidden: boolean = false; // la zone est masquée
  useSubGrid = false; // détournement de la freeZone pour injecter le subGrid
  public subGrid: ComponentRef<any> = null;


  public get freezonelabel(): string {
    let res: string;
    if(this.freezoneHidden) {
      res = WizTranslationManager.getInstance().translateKey('$.common.open.$');
    } else {
      res = WizTranslationManager.getInstance().translateKey('$.common.hide.$');
    }
    return res;
  }

  public get freezoneicon(): string {
    // let res: string = 'reduce';
    let res: string;
    if(this.freezoneHidden) {
      res = 'creation';
    } else {
      res = 'reduce';
    }
    // console.log("TODO selon value (reduce / creation)", this._data?.wcio?.pgrp, res);
    return res;
  }


  /** configuration de l'editeur html */
  public editorConfig: AngularEditorConfig = {
    width: '100%',
    height: '100%',
    defaultFontSize: '2',
    editable: false,
    enableToolbar: false,
    showToolbar: false,
    spellcheck: false,
    //imageResizeSensitivity: 0
  }
  /* ##############################################################################
                  accesseurs dynamiques pour le rendu visuel
  ############################################################################## */

  /** affichage (ou pas) du libellé */
  public get showLabel():boolean {
    return this._data.wcio?.slbl;
  }

  /** libellé du composant */
  public get componentlabel(): string {
    let result: string = this.data?.label;
    return result;
  }

  /* ##############################################################################
                  construction initiale
  ############################################################################## */


  ngAfterViewInit() { // construction et pose des écouteurs
    setTimeout(() => {  
      this.build(); // construction
      this.feed();
      // if(this.fkd?.fullCode === 'M_CODEART#I') {
      //   console.log('ffr M_CODEART#I', 'ngAfterViewInit');
      // }
      this.checkValueDisabled();
      if (!!this.data?.widget) { // pas de ref au pivot en mode templating   
        /** modif sur n'importe quel élément, pour mise à jour du form */
        WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE, this.dispatchUpdate);
        /** fin de contrôle d'intégrité du formulaire, possible modif de ma valeur, refresh dans ce cas */
        WizEventManager.addListener(this, this.data.widget, ALK_EVENT_TYPE.FORM_REFRESH_FIELDS, this.refreshFromOutside);
        
        // console.log(this.data?.fkd?.fullCode, this.useddext);
        this.cdref.markForCheck();
      }
    }, 0);
  }

  ngOnDestroy() { // suppression des écouteurs
    if (!!this.data?.widget) { // pas de ref au pivot en mode templating 
      /** modif sur n'importe quel élément, pour mise à jour du form */
      WizEventManager.removeListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE);
      
      /** fin de contrôle d'intégrité du formulaire, possible modif de ma valeur, refresh dans ce cas */
      WizEventManager.removeListener(this, this.data.widget, ALK_EVENT_TYPE.FORM_REFRESH_FIELDS); 
    }
  }

  /**
   * construction du rendu graphique et mise en place de la conf selon le type
   */
  private build(): void { 
    if(!this.fkd) { // gestion des champs libres
      this.useFreeField();
      return;
    }

    if (this.fkd.isKey) { // rendu des éléments de clé et de filterKey
      this.useKeyField();
      return;
    }

    if(this.fkd.isMeasure) { // rendu des mesures
      this.useMeasureField();
      return;
    }
  }

  /**
   * utilisation des contenus libres
   */
  private useFreeField(): void {
    // console.log('useFreeField', this.data.wcio.cod);
    switch(this.data.wcio.cod.split(ViewData.CONTEXT_SEPARATOR)[0]) {
      case ViewData.FORM_HTML: // formulaire HTML libre
        this.formatedValue = this.data.wcio.lbl;  
        this.usefreeGrp = true;
        // console.log('useFreeField', this.ae);
        // if(this.ae) {
        //   this.ae.config = this.editorConfig;
        //   this.ae.placeholder='';
        //   this.ae.showPlaceholder = false;
        //   this.ae.writeValue(this.formatedValue);
        // }
        setTimeout(() => {
          if(this.ae) {
            this.ae.config = this.editorConfig;
            // this.ae.placeholder='';
            // this.ae.showPlaceholder = false;
            this.ae.writeValue(this.formatedValue);
            this.readyfreeGrp = true;
            this.cdref.markForCheck();
          }
          // console.log('useFreeField timed', this.ae);
        }, 0);

      break;
      case ViewData.FORM_ACTION: // bouton d'action
        this.cnx = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(this.data.wcio.lbl);
        this.usebt = true; 
      break;
      case ViewData.FORM_IMAGE: // image libre
        if(!!this.data.wcio.lbl) {
          this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(this.data.wcio.lbl);
        } else {
          this.imgSrcObs = of(null);
        }
        this.usefreeImgGrp = true;
      break;
      case ViewData.FORM_ZONE:

        this.usefreeZone = true;
        this.freezoneHidden = !!this.widget.hiddenGroups?.get(this.data.wcio.pgrp);
        // mode injection de subGrid
        if(this.data.wcio.pgrp === '@@SUB@@') {
          this.useSubGrid = true;
          setTimeout(() => { 
            if(this.widget.subGrid) {
              this.gridInjector.insert(this.widget.subGrid.hostView);
            }      
          }, 0);
        }

      break;
    }
  }


  /**
   * utilisation des champs clés
   */
  private useKeyField(): void {
    
    this.formatedValue = this.data; // on va passer tout le formField au composant ddExt
    this.wizmandatory = !this.fkd.isFilterKey; // le champ est obligatoire, sauf pour les filterKeys
   
    // console.log('this.fkd', this.fkd.fullCode, this.fkd.isSequence);
    if(this.fkd.isSequence) {
      this.useSeqGP = true;
    } else {
      this.useddext = true;
      if (this.fkd.isFreedata) { // freedata, on cherche un éventuel args pour le rendu
        const rawVal: string = this.widget?.keyPartMap?.get(this.fkd.fullCode); // les données sont calculées par le formWidget
        if (!!this.data.wcio.fdvf && this.data.wcio.fdvf !== WizConstants.FIELD_LABEL &&  this.data.wcio.fdvf !== WizConstants.FIELD_SHORT_CODE) { // rendu custom sur FD
          const subArg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(this.fkd.code, this.data.wcio.fdvf);
          // collecte du bon FDV
          this.freedataCustomRenderer(subArg, rawVal);
        } 
      }
    }
   
    // TODO TODO pareil pour les chronocodes
  }

  /**
   * rendu des champs sur un Freedata
   * @param arg 
   * @param valueStr 
   * @returns 
   */
  private freedataCustomRenderer(arg: FreedataArgsVO, rawVal: string): void {
    this.argContainer.wizDisabled = true; // non éditable pour les champs complémentaires
    this.useddext = false; // on va utiliser un rendu custom
    this.wizmandatory = false; // donc pas mandatory

    if(!arg) {
      // le champ demandé dans le formulaire n'existe pas
      return;
    }

    let fdvValueStr: string = null; // le code FD#FDV

    if (!!rawVal) { // collecte du FreedataValue
      const fdv: FreedataValueVO = this.model.freedataEngine.getFreedataValue(this.fkd.code, rawVal);
      fdvValueStr = fdv?.argsObjVO[arg.code]; // la valeur du champ pour ce FD
    }

    switch (arg.dataType) {
      case FIELD_KIND.OBJECT: // champ FD d'un FD... On va restituer en string
        if (fdvValueStr) {
          const parts: string[] = fdvValueStr.split(ViewData.CONTEXT_SEPARATOR);
          if (parts.length === 2) { // il faut les 2 morceaux
            const finalFDV: FreedataValueVO = this.model.freedataEngine.getFreedataValue(parts[0], parts[1]);
            fdvValueStr = finalFDV.trsLabel;
          }
        }
        this.formatedValue = fdvValueStr;
        this.useti = true;
        break;
        case FIELD_KIND.WORKFLOW:
          let settings: any = arg.settings;
          if(!!this.context.pmdexParams) { // override par params
            settings = this.model.widgetEngine.pmdExParams(this.context);
          }

          let strRes: string = this.model.workflowEngine.formatWorkflow(settings, rawVal);
          if(strRes) {
            let objRes: any = JSON.parse(strRes);
            if(!!objRes.image) {
              this.workImageBlob = objRes.image;
              this.workImage = AttachmentService.getInstance().downloadAttachmentForWidget(objRes.image, true);
            } else {
              this.workImage = of(null);
            }
            if(!!objRes.media) {
              this.workFile = objRes.media;
            } else {
              this.workFile = null;
            }
            this.workIcon = objRes.icon || null;
            this.workflowLabel = objRes.keys?.join(" ") || null;
          } else {
            this.workImageBlob = null;
            this.workImage = of(null);
            this.workFile = null;
            this.workIcon = null;
            this.workflowLabel = null;
          }
          this.useworkflow = true;  
        break; 

      case FIELD_KIND.BINARY:
      case FIELD_KIND.BINARY_MULTI:
        if(!!fdvValueStr) {
          let firstMed: string = fdvValueStr.split(WizConstants.KEY_SEPARATOR)[0];
          // console.log('BINARY_MULTI FDV', firstMed);
          this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(firstMed);
          this.imgBlobid = firstMed;
          this.formatedValue = firstMed;
        } else {
          this.imgSrcObs = of(null);
          this.imgBlobid = null;
          this.formatedValue = null;
        }
        this.usefreeImgGrp = true;
        break;
      case FIELD_KIND.NUMBER:

        let format = arg.format;
        if(format) {
          let formatVO = this.model.formatEngine.getFormat(format.split(ViewData.KEY_SEPARATOR)[0], format.split(ViewData.KEY_SEPARATOR)[1]);
          if(formatVO) {
            this.decimal = formatVO.precision; //  || 2;
          } else {
            this.decimal = 2;
          }
        } else {
          this.decimal = 2;
        }
     
        this.formatedValue = Number(fdvValueStr);
        this.useni = true;
        break;
      case FIELD_KIND.INT:
        this.decimal = 0; 
        this.formatedValue = Number(fdvValueStr);
        this.useni = true;
        break;
      case FIELD_KIND.DATE:
        this.formatedValue = Number(fdvValueStr);
        this.useda = true;
        break;
      case FIELD_KIND.BOOLEAN:
        this.formatedValue = fdvValueStr === '1' ? true : false;
        this.usecb = true;
        break;
      case FIELD_KIND.COLOR: // une couleur
        this.usecolor = true; 
        this.formatedValue = fdvValueStr; 
        break;
      default:
        this.formatedValue = fdvValueStr;
        this.useti = true;
        break;
    }
  }

  /**
   * utilisation des mesures
   */
  private useMeasureField(): void { 
      const meas: Measure = this.fkd.measure;
      const rendererKind: string = this.model.dataEngine.rendererKind(this.fkd.datakind);
      
      // console.log('useMeasureField', meas.code, this.fkd.datakind, rendererKind);


      if (rendererKind === FIELD_KIND.STRING) { // gestion des formats texte
        if(meas.editRegex) {
          this.forceRestrict = new RegExp('^'+meas.editRegex+'$');
        } else {
          this.forceRestrict = null;
        }

        if(meas.upper) {
          this.forceCaps = 'upper-case-input';
        }

        // ici patch... Prendre en compte le format pour le rendu, datakind par défaut
        if(!!this.data.wcio.fmt) { // présence d'un format
          const twoPart: string = this.data.wcio.fmt.split(ViewData.KEY_SEPARATOR)[1];
          if(twoPart === 'MEDIA') { // rendu média
            // TODO TODO 
            const dataStr: string = null; // this.data.widget?.keyPartMap.get(this.fkd.fullCode); // la chaine de texte
            this.formatedValue = dataStr;
            this.usemedia = true;              
          } else if(twoPart === 'HYPER') { // rendu lien hypertexte
            // TODO TODO 
            const dataStr: string = null; //this.data.widget?.keyPartMap.get(this.fkd.fullCode); // la chaine de texte
            const dataParts: string[] = dataStr?.split(ViewData.KEY_SEPARATOR);
            if(!!dataParts) {
              this.linkUrl = dataParts[0];
              this.linkLabel = dataParts.length > 1 ? dataParts[1] : dataParts[0];
            }
            this.uselinkGp = true; 
          } else { // fonctionnement normal
            this.wizmax = !!meas.maxValue ? Number(meas.maxValue) : 50;
            this.useti= true; 
          }
        } else { // pas de format sur la mesure
          this.wizmax = !!meas.maxValue ? Number(meas.maxValue) : 50;
          this.useti= true; 

        }
      } else if (rendererKind === FIELD_KIND.NUMBER) {
        if(this.fkd.datakind === FIELD_KIND.INT) {
          this.decimal = 0;
        } else {
          this.decimal = !!meas.nbDecimal ? meas.nbDecimal : 2;
        }
        
        this.wizmin = !!meas.minValue ? Number(meas.minValue) : null;
        this.wizmax = !!meas.maxValue ? Number(meas.maxValue) : null;
        this.useni = true;
      } else if (rendererKind === FIELD_KIND.DATE) {
        this.wizmin = !!meas.minValue ? WizDateUtils.stringToDate(meas.minValue) : null;
        this.wizmax = !!meas.maxValue ? WizDateUtils.stringToDate(meas.maxValue) : null;
        this.useda = true;
      } else if (rendererKind === FIELD_KIND.BOOLEAN) {
        this.usecb = true; 
      } else if (rendererKind === FIELD_KIND.COMMENT) {
        this.wizmax = !!meas.maxValue ? Number(meas.maxValue) : 255; 
        this.useta = true; 

        if(meas.editRegex) {
          this.forceRestrict = new RegExp('^'+meas.editRegex+'$');
        } else {
          this.forceRestrict = null;
        }
      } else if (rendererKind === FIELD_KIND.BINARY) { // et multi
        this.useimgGp = true;
        // console.log('useimgGp', meas.code, this.fkd.datakind, rendererKind);
      } else if (rendererKind === FIELD_KIND.WORKFLOW) {
        this.useworkflow = true;
      }  else if (rendererKind === FIELD_KIND.COLOR) {
          this.usecolor = true;
      } else if (rendererKind === FIELD_KIND.FILE) {
        this.useDropGrp = true;
      } else if (rendererKind === FIELD_KIND.FILTER) {
        // console.log('m filter', meas);
        this.useddext = true;
      } else if (rendererKind === FIELD_KIND.CROSS_FILTER) {
        // console.log('form cross filter', meas);
        this.useddext = true;
      }
       else if (rendererKind === FIELD_KIND.LIST) {
        this.uselistGP = true;
      } else if (rendererKind === FIELD_KIND.THRESHOLD) {
        this.usethresholdGP = true;
      } else if (rendererKind === FIELD_KIND.ANY) {
        this.uselistGP = true;
      }
  }

  /* ##############################################################################
                  cycle de vie
  ############################################################################## */

  /**
   * alimentation initiale ou par injection de valeurs sur peuplement automatique
   * public car peut être appelé par le BlGridsterItem lors de la mise à jour de la configuration du champ
   */
  public feed(): void {
    if (!this.fkd) { // rendu libre rien à alimenter
      return;
    }
    const rawVal: string = this.widget?.keyPartMap?.get(this.fkd.fullCode); // les données sont calculées par le formWidget
    this.rawValue = rawVal; // mémorisation de la valeur en cours
    
    if (this.fkd.isKey) { // les key / filters
      
      if (this.fkd.isFreedata) { // freedata, on cherche un éventuel args pour le rendu
        const rawVal: string = this.widget?.keyPartMap?.get(this.fkd.fullCode); // les données sont calculées par le formWidget
        if(this.fkd.isSequence) {
          this.formatedValue = rawVal;
        } else if (!!this.data.wcio.fdvf && this.data.wcio.fdvf !== WizConstants.FIELD_LABEL &&  this.data.wcio.fdvf !== WizConstants.FIELD_SHORT_CODE) { // rendu custom sur FD
          const subArg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(this.fkd.code, this.data.wcio.fdvf);
          // collecte du bon FDV
          this.freedataCustomRenderer(subArg, rawVal);
        } else {
          this.formatedValue = this.data; // on force le refresh sur le dropExtented, pour application de la sélection
          if(!!this.ddext) { // on force, pas de détection de changement sur le data
            this.ddext.data = this.formatedValue;
          }
        }
      } else { // CHRONO, TODO
        this.formatedValue = this.data; // on force le refresh sur le dropExtented, pour application de la sélection
        if(!!this.ddext) { // on force, pas de détection de changement sur le data
          this.ddext.data = this.formatedValue;
        }
      }

    
    } else { // les mesures
      const rendererKind: string = this.model.dataEngine.rendererKind(this.fkd.datakind);
      if (rendererKind === FIELD_KIND.STRING) {
          this.formatedValue = rawVal;
        } else if (rendererKind === FIELD_KIND.COMMENT) {
          this.formatedValue = rawVal;
        } else if (rendererKind === FIELD_KIND.NUMBER) {
          // this.formatedValue = null;
          this.formatedValue = rawVal !== null ? Number(rawVal) : null;
          // console.log('ffr', this.fkd.fullCode, this.formatedValue);
          // setTimeout(() => {
            if(!!this.ni) {
              this.ni.wizNumber = this.formatedValue;
            }
            // this.formatedValue = rawVal !== null ? Number(rawVal) : null;
            // console.log('ffr', this.fkd.fullCode, this.formatedValue);
            // this.ni.re
            // this.cdref.markForCheck();
            // forcer le rendu sur numericInput ??
            
          // }, 0);


        } else if (rendererKind === FIELD_KIND.DATE) {
          

          this.formatedValue = Number(rawVal);
        } else if (rendererKind === FIELD_KIND.BOOLEAN) {
          this.formatedValue = rawVal === '1' ? true : false;// WizBooleanUtils.stringToPureBoolean(rawVal);
          if(this.cb) {
            this.cb.wizChecked = rawVal === '1';
          }
          
          //this.cdref.markForCheck();
          // console.log('dafuck cbx', this.formatedValue);
          // this.formatedValue = rawVal === '1';
          // this.formatedValue = rawVal || '0';
        } else if (rendererKind === FIELD_KIND.COLOR) {
          this.formatedValue = rawVal || StyleEngine.STYLE_DEFAULT_WIDGET_BACKGROUND_COLOR;
        } else if (rendererKind === FIELD_KIND.ACTION) {       
          this.cnx = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(rawVal);
        } else if (rendererKind === FIELD_KIND.FILTER) {
          this.formatedValue = this.data; // on force le refresh sur le dropExtented, pour application de la sélection
          if(!!this.ddext) { // on force, pas de détection de changement sur le data
            this.ddext.data = this.formatedValue;
          }
        } else if (rendererKind === FIELD_KIND.CROSS_FILTER) {
          //console.log('TODO TODO form cross Filter');
          this.formatedValue = this.data; // on force le refresh sur le dropExtented, pour application de la sélection
          if(!!this.ddext) { // on force, pas de détection de changement sur le data
            this.ddext.data = this.formatedValue;
          }
        } else if (rendererKind === FIELD_KIND.BINARY) {
          // prendre la 1ère image pour les multi
          // console.log('feed BINARY', rawVal, this.fkd.code)
          if(!!rawVal) {// this.data.wcio.lbl) {
            let firstMed: string = rawVal.split(WizConstants.KEY_SEPARATOR)[0];
            // console.log('BINARY_MULTI Meas', firstMed);
            this.imgSrcObs =  AttachmentService.getInstance().downloadAttachmentForWidget(firstMed);
            this.imgBlobid = firstMed;
            this.formatedValue = firstMed;
          } else {
            this.imgSrcObs = of(null);
            this.imgBlobid = null;
            this.formatedValue = null;
          }
        } else if (rendererKind === FIELD_KIND.WORKFLOW) {
          
          let settings: any = this.data.fkd.measure.settings;
          if(!!this.context.pmdexParams) { // override par params
            settings = this.model.widgetEngine.pmdExParams(this.context);
          }

          let strRes: string = this.model.workflowEngine.formatWorkflow(settings, rawVal);
          // console.log(this.fkd.fullCode, rawVal, strRes);
          if(strRes) {
            let objRes: any = JSON.parse(strRes);
            if(!!objRes.image) {
              this.workImageBlob = objRes.image;
              this.workImage = AttachmentService.getInstance().downloadAttachmentForWidget(objRes.image, true);
            } else {
              this.workImage = of(null);
            }
            if(!!objRes.media) {
              this.workFile = objRes.media;
            } else {
              this.workFile = null;
            }
            this.workIcon = objRes.icon || null;
            this.workflowLabel = objRes.keys?.join(" ") || null;
          } else {
            this.workImageBlob = null;
            this.workImage = of(null);
            this.workFile = null;
            this.workIcon = null;
            this.workflowLabel = null;
          }
        } else if (rendererKind === FIELD_KIND.FILE) {
          // console.log('feed FILE', rawVal);
          if(rawVal) {
            try{
              this.mediaReference = JSON.parse(rawVal);
            }
            catch(e: any) {
              this.mediaReference = null;// {fileName: 'err', fileType: 'err', blobId: 'err', shortFileName: 'err', v2: false, directory: null};
            }
          } else {
            this.mediaReference = null;
          }
        } else if (rendererKind === FIELD_KIND.LIST) {
          this.formatedValue = this.model.listFieldEngine.generateRenderer(this.widget.fakeFei, this.data.fkd, [this.clone], '<br>');
        } else if (rendererKind === FIELD_KIND.THRESHOLD) {
          this.formatedValue = this.model.listFieldEngine.generateThresholdRenderer(this.widget.fakeFei, this.data.fkd, [this.clone], '<br>');
        } else if (rendererKind === FIELD_KIND.ANY) {
          this.formatedValue = rawVal;
        }
    }

    // this.cdref.markForCheck();
  }

  /** accesseur sur la valeur du champ */
  public getValue(): FormItemObj {
    if (!this.fkd) {
      return null;
    }
    
    let result: FormItemObj = null;
    const rendererKind: string = this.model.dataEngine.rendererKind(this.fkd.datakind);

    if (this.fkd.isKey) { // les ddExt portent la currentValue
      result = new FormItemObj(this.data, this.ddext.currentValue, '','');
    } else if (rendererKind === FIELD_KIND.STRING) {
      // une mesure de type texte
      result = new FormItemObj(this.data, this.ti.wizValue, '', '');
    } else if (rendererKind === FIELD_KIND.COMMENT) {
      // une mesure de type texte long
      // console.log('ff comment', this.ta.wizValue);
      result = new FormItemObj(this.data, this.ta.wizValue, '', '');
    } else if (rendererKind === FIELD_KIND.NUMBER) {
      // une mesure numérique
      if (!!this.ni.wizValue) {
        result = new FormItemObj(this.data, this.ni.wizNumber.toString(), '', '');
      }
    } else if (rendererKind === FIELD_KIND.BOOLEAN) { // un bool
      result = new FormItemObj(this.data, this.cb.wizValue, '', '');
    } else if (rendererKind === FIELD_KIND.COLOR) { // un uint
      let realColor: string = MathUtils.RGBA2HEX(this.cellBlockBack.nativeElement.style.backgroundColor);
      result = new FormItemObj(this.data, realColor, '', '');
    } else if (rendererKind === FIELD_KIND.DATE) {
      // une mesure de type date
      result = new FormItemObj(
        this.data,
        this.da.wizDateValue ? WizDateUtils.dateToString(this.da.wizDateValue) : null, '', '');
    } else if (rendererKind === FIELD_KIND.FILE) { // un fichier
      let media: string = this.mediaReference ? JSON.stringify(this.mediaReference) : null;
      result = new FormItemObj(this.data, media, '', '');
    } else if (rendererKind === FIELD_KIND.BINARY) { // une image
      // let media: any = this.img.sourceObservable.pipe(take(1)).subscribe(value => value);
      // console.log('get image', this.rawValue);
      result = new FormItemObj(this.data, this.rawValue, '', '');
    } else if (rendererKind === FIELD_KIND.FILTER) { // un filtre
      // let media: any = this.img.sourceObservable.pipe(take(1)).subscribe(value => value);
      // console.log('ffr getvalue', this.ddext.currentValue);
      result = new FormItemObj(this.data, this.ddext.currentValue, '','');
    } else if (rendererKind === FIELD_KIND.CROSS_FILTER) { // un filtre
      // let media: any = this.img.sourceObservable.pipe(take(1)).subscribe(value => value);
      // console.log('ff crossFilter getvalue', this.ddext.currentValue);
      result = new FormItemObj(this.data, this.ddext.currentValue, '','');
    } else if (rendererKind === FIELD_KIND.WORKFLOW) { // un workflow
      // let media: any = this.img.sourceObservable.pipe(take(1)).subscribe(value => value);
      // console.log('get WORKFLOW', this.rawValue);
      result = new FormItemObj(this.data, this.rawValue, '', '');
    } else if (rendererKind === FIELD_KIND.LIST) { // une lite de valeurs
      // console.log('get LIST', this.rawValue);
      result = new FormItemObj(this.data, this.rawValue, '', '');
    } else if (rendererKind === FIELD_KIND.THRESHOLD) { // un seuil
      // console.log('get LIST', this.rawValue);
      result = new FormItemObj(this.data, this.rawValue, '', '');
    }
    return result;
  }

  /**
   * modification sur un élément du form, on contrôle si je suis impacté, pour refresh
   * @param e AlkEvent data: la keyPartMap du widget
   */
  private refreshFromOutside(e: AlkEvent): void {
    if(!this.fkd) { // champ fake
      return;
    }
    if(this.rawValue !== e.data.get(this.fkd.fullCode)) {
      this.rawValue = e.data.get(this.fkd.fullCode);
      this.feed();
    }

    // je suis peut-être impacté par un autre
    // console.log('refreshFromOutside', this.fkd.fullCode,this.rawValue);
    this.checkValueDisabled(); // contrôle d'édition selon editRestrict sur la mesure
    this.checkError(); // et contrôle d'erreur
  }


  /** 
   * signaler une modif sur un champ pour activation du save / cancel sur le formulaire
   * et synchro / calcul des éléments
   */
  private dispatchUpdate(e: WizEvent): void {
    if(this.useSubGrid) {
      return; // neutralisation sur subGrid
    }


    if(!!e && e.component === this.img) {
      this.rawValue = e.value;
      // console.log('dispatchUpdate img', e.value);
      this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(this.rawValue);
      this.imgBlobid = this.rawValue;
      //this.img.sourceObservable = AttachmentService.getInstance().downloadAttachmentForWidget(this.rawValue);
      // console.log('ffr', this.rawValue, this.data.fkd.fullCode, this.img.sourceObservable);
    } else {
      // console.log('ffr dispatchUpdate', e);
      this.rawValue = this.getValue()?.value;
    }

    
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: this.data, item: this.getValue()}));
  
          
    let inject: string = (this.data.fkd?.measure?.settings as any)?.key;
    // console.log('backFromCrossedPop inject', inject, this.widget);
    if(!!inject) {

      // TODO choper la cible sur FORM & injecter
      let wcio: WidgetConfigurationItemObj = cloneDeep(this.data.wcio);
      wcio.cod = inject;
      // prise du bon wcio
      const fakeFF: FormFieldObj = new FormFieldObj(this.widget, this.widget.fakeFei, wcio, false, this.widget.clone);


      WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: fakeFF, item: this.getValue()}));
  
      // this.widget.keyPartMap.set(inject, this.rawValue);
      // TODO prise du bon FF sur le widget pour simuler sa modif...
      // let ff: FormFieldObj = this.widget.
      // WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: this.data, item: this.getValue()}));
    }

  }

  /** contrôle de la présence de saisie invalide suite à la modif d'une autre mesure */
  private checkError(): void {
    let errors = this.validationContainer.check(true, true);
  }

  /**
   * affichage de l'erreur sur un champ, depuis le set d'erreur du widget
   */
  public checkValueIntegrity(): WizValidatorFn {
  return (): WizValidationErrors | null => {
    if (!!this.widget?.errorSet?.has(this.fkd?.fullCode)) {
      const temp: WizValidationError = {
        wizError: this.widget?.errorSet.get(this.fkd.fullCode),//  '$.common.error.$',
        wizErrorParams: [],
      };
      return [temp];
    }

      return null;
    };
  }

  /**
   * // TODO TODO gérer dans le formWidget
   * désactiver la saisie des mesures selon le editRestrict
   */
  public checkValueDisabled(e: AlkEvent = null): boolean {
    if (!this.fkd) { // champ fake, pas de possibilité d'édition
      return true;
    }
    
    if(this.data.wcio.ro) { // lecture seule sur le champ
      this.argContainer.wizDisabled = true;
      this.wizdisabled = true;
      return true;
    }

    if(!this.clone || !this.clone.bl) { // pas de données...
      return true;
    }

    if(!this.fei.canUpdateItem([this.clone], true)) { // pas de droits en écriture
      this.argContainer.wizDisabled = true; 
      this.wizdisabled = true;
      // this.ddext.wizDisabled = true; // FD 
      return true; // gestion autorisations de base
    }

    const fkd: FeiKeyDef = this.fkd; // arrivé ici, on doit contrôler la données

    if(fkd.isKey && !fkd.isFilterKey) { // on est sur une clé (et pas une filter)
      if(this.clone.bl?.id > 0) { // on est pas en mode création
        this.wizdisabled = true;
        this.argContainer.wizDisabled = true;
      }
      return true; // fin de traitement pour les Keys
    }
    
    // contrôle des mesures
    const meas: Measure = fkd.measure;
    if (!meas) {
      return true; // ce n'est pas une mesure, rien à faire ici
    }

    if (!meas.editable && // mesure non éditable
      fkd.datakind !== FIELD_KIND.ACTION && // mais pas sur les fonctions Connect
      fkd.datakind !== FIELD_KIND.BINARY // mais pas sur les images
      ) {  
      this.argContainer.wizDisabled = true; 
      return true;
    }

    let mayEdit: boolean = true;
    if(!meas.editRestrict) { // pas de restriction d'édition, OK
      // rien à faire
    } else {
      // console.log('ffr checkEditAvailable', meas.code, mayEdit);
      if((this.widget as IForm).fakeFei) {
        // if(fkd.fullCode === 'M_CODEART#I') {
        //   let check: string = BaselineEngine.getRawKeyOrValue(this.widget.fakeFei, this.clone,  'M_CODELOCK#I' );
          
        //   console.log('ffr M_CODEART#I', meas.code, check, mayEdit);
        // } else {
        mayEdit = this.widget.checkEditAvailable(this.widget.fakeFei, meas, [this.clone], true);  
        //}
        
      }

      // if(fkd.fullCode === 'M_CODEART#I') {
      //   let check: string = BaselineEngine.getRawKeyOrValue(this.widget.fakeFei, this.clone,  'M_CODELOCK#I' );
      //   console.log('ffr M_CODEART#I', meas.code, check, mayEdit);
      // }
    }

    this.wizdisabled = !mayEdit;
    this.argContainer.wizDisabled = !mayEdit;
    // if(this.ddext) {
    //   this.ddext.wizDisabled = !mayEdit;
    // }
    
  }

  /** fonction liée au bouton d'action */
  public doArgAction(): void {   

    let cnxCode: string = null;
    if(!this.fkd) { // un fake
      cnxCode = this.data.wcio.lbl;
    } else { // une mesure action ou un rendu action de FD
      // console.log('connect', this.data);
      cnxCode = this.widget?.keyPartMap.get(this.fkd.fullCode); // les données sont calculées par le formWidget
    }

    if(!!cnxCode) {
      this.model.connectEngine.doArgActionExt(cnxCode, this.widget, [this.clone]);
    } 
  }

  /* ##############################################################################
                   gestion du colorPicker pour la conf du header
     ############################################################################## */

  /**
   * affichage de la popUp du colorPicker
   * @param pEvent click
   */
  public showColorPicker(pEvent: Event): void {
    pEvent.stopPropagation();
    pEvent.preventDefault();

    if(!this.checkValueDisabled(null)) {
      ColorPickerPop.show(this.cellBlockBack.nativeElement, pEvent.target, this.formatedValue, this.backFromPicker.bind(this));
    }
  }

  /**
   * retour de colorPicker, alimentation des couleurs du header
   *
   * @param target le span source pour font ou background
   * @param color la couleur du picker
   */
  public backFromPicker(target: any, color: string): void {
    
    let realColor: string = MathUtils.RGBA2HEX(color);
    // this.rawValue = realColor;
    // this.formatedValue = realColor;
    this.cellBlockBack.nativeElement.style.backgroundColor = realColor;
    this.dispatchUpdate(null);
   }

  /** click sur les icones de suppression de style de header */
  public resetColor(who: string): void {
    if(!this.checkValueDisabled(null)) {
      this.cellBlockBack.nativeElement.style.backgroundColor = StyleEngine.STYLE_DEFAULT_WIDGET_BACKGROUND_COLOR;
      this.dispatchUpdate(null);
    }
  }


  public get colorCursor(): string {
    if(this.checkValueDisabled(null)) {
      return 'default';
    } else {
      return 'pointer';
    }
  }



 /* ##############################################################################
       gestion du dnd de fichier
  ############################################################################## */
  
  /** on utilise le lien vers un fichier, et il existe */
  public get dropFull():boolean {
    // console.log('dropFull', this.useDropGrp, this.mediaReference);
    return this.useDropGrp && !!this.mediaReference;
  }

  /** readonly sur les images, pas de poubelle */
  public get readOnly():boolean {
    return this.argContainer?.wizDisabled;
  }

  /**
     * Demande de chargement d'un fichier
     */
  public selectFile(): void {

    let params: UploadParameter = {
      callback: null, // sera alimenté par le batchEngine
      accept: [WIZ_UPLOAD_ACCEPT_FORMAT.FILE_ANY],
      multiple: false, // false par défaut
      maxSize: 30, // 30 Mo
      elementRef: this.dropGrp.elementRef,
      targetPath: this.data?.arg?.settings?.path || null,
      viewCallback: this.backFromSelect.bind(this)
    }
    this.model.batchEngine.loadFile(params);
  }

  /**
   * retour de sélection de fichier
   * @param params 
   */
  private backFromSelect(params: UploadParameter): void {
    if(params.files?.length > 0) {
      params.viewCallback = this.backFromDrop.bind(this);
      this.model.batchEngine.dropFile(params);
    }
  } 

  /**
   * Demande de chargement par drop
   */
  public dropFileV2(evt: DragEvent): void {
    
    evt.preventDefault();
    evt.stopImmediatePropagation();
    const files = evt.dataTransfer.files;
    let file: File = files[0];
  
    let params: UploadParameter = {
      callback: null, // sera alimenté par le batchEngine
      accept: [WIZ_UPLOAD_ACCEPT_FORMAT.FILE_ANY],
      multiple: false, // false par défaut
      maxSize: 30, // 30 Mo
      elementRef: this.dropGrp.elementRef,
      targetPath: this.data?.arg?.settings?.path || null,
      files: [file],
      viewCallback: this.backFromDrop.bind(this)
    }
    
    this.model.batchEngine.dropFileV2(params);
  }

  /**
   * retour de chargement, enregistrement
   * @param media 
   * @param blobId 
   */
  private backFromDrop(media: Attachment): void {  
    // console.log('back from file drop', media);
    this.mediaReference =  {
      
      fileName: media.fileName,
      fileType: media.fileType,
      blobId: media.fileName,
      shortFileName: media.fileName,
      v2: true,
      directory: media.directory
    };
    this.cdref.markForCheck();
    let ev: WizEvent = new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoAddFile, media);
    this.dispatchUpdate(ev);
    // WizEventManager.dispatchEvent(this.icoAddFile.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoAddFile, media));
  }

  /**
   * suppression de la pièce jointe
   */
  public clearDropFile(): void {
    this.mediaReference = null;
    this.dispatchUpdate(null);
    // WizEventManager.dispatchEvent(this.icoDelFile.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoDelFile, null));
  }

  /**
   * chargement de la pièce jointe
   */
  public loadDropFile(): void {
    AttachmentService.getInstance().filedownloadForWidget(this.mediaReference);
  }

 /* ##############################################################################
        gestion des médias
  ############################################################################## */

  /** présence d'une image, pour affichage de la poubelle */
  public get hasImage(): boolean {
    const valueStr: boolean = !!this.imgSrcObs;
    return !!valueStr;
  }

  /**
   * Demande de chargement d'une image
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public clickForUpload(latency: number): void {

    if(!!this.rawValue && latency > 400) {
      this.seeImage();
    } else {
      let params: ImageUploadParameter = {
        component: this.img,
        elementRef: this.img.elementRef,
        dom: this.model.domainCode,
        bu: this.model.businessUnitCode,
        vision: ViewData.wildcardMainVision,
      }
      this.model.batchEngine.loadImage(params);
    }
  }

  /**
   * demande d'ouverture sur l'image picker par clavier; touche entrée ou espace
   * @param event event clavier
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public keydownForUpload(event: KeyboardEvent): void {
    const isEnterKey = event.key === VALUE_ENTER; // touche entrée
    const isSpaceKey = event.code === CODE_SPACE; // touche espace
    if (isEnterKey || isSpaceKey) {
      this.clickForUpload(0);
    }
  }

  /**  de suppression des... icones */
  public clearImage(): void {
    this.img.sourceObservable = of(null);
    WizEventManager.dispatchEvent(this.img.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.img, null));
  }

  /**
   * contexte. Attention, non disponible dans la vue Freedata
   */
  public get context(): WidgetConfigurationItemObj {
    return  this.data?.wcio; 
  }


  public get injectClass(): string {
  let myclass: string = 'voidme';
  if(!!this.context?.sty) {
    myclass = this.context?.sty;
  }
  return myclass;
  }

  private zoomPop: WizPopUp; // la popUp de zoom sur les images
  /**
   * zoom sur une image
   */
  public seeImage(e: Event= null): void {
      let params: zoomPopParams = {
        zoomPop: this.zoomPop,
        blobid: this.imgBlobid,
        // arg: this.data.arg,
        //fdvDS: this.data.ds
      }
    
    PopUtils.showZoomPop(params);
  }

  public fastChange(e: WizEvent): void {
    // console.log('fastChangeOnNumeric', e);
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_KEY, {field: this.data}));
  }

 /* ##############################################################################
       gestion des workflows
  ############################################################################## */

  public showWorkflow(e: any): void {
    // console.log('showWorkflow', e);

    let title = WizTranslationManager.getInstance().translateKey('$.workflow.title.$');

    let datas: PivotCellEditPopData = { 
      kind: WIDGET_GLOBAL_KIND.BASELINE,
      title, 
      label: null, 
      value: this.rawValue, // realValue, //
      column: null,
      fkd: this.fkd, 
      line: this._data.widgetLine, 
      pack: null, 
      widget: this.widget, 
      pointer: e as PointerEvent,
      callback: this.backFromEditPop.bind(this)};

    /** ouverture de la pop d'édition en masse */
    // dispatch de l'event, sert possiblement pour sélection rapide sur le master, synchro des esclaves
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.SHOWPOP, datas));
  }

  /**
   * callBack de retour de la popUp d'édition en masse
   * @param data PivotCellEditPopData, avec UpdateRequest
   */
  public backFromEditPop(data: PivotCellEditPopData): void {
    this.rawValue = data.updates?.value;
    //console.log('back from edit workflow 1', data, this.rawValue);
    
    // pour signaler une modif au form (sinon, même clé de workflow)
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.MESSAGE_UPDATE, {field: this.data, value: data.updates?.value}));
    // (this.widget as FormWidget).updatedMessage.set(this.data.fkd.fullCode,this.rawValue);
    // console.log('back from edit workflow 2', data, this.rawValue);
    // WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_UPDATE, {field: this.data, value: data.updates?.value}));
    this.dispatchUpdate(null);
    this.feed();
  }

  /* ##############################################################################
          gestion des  containers
     ############################################################################## */

    public showHideZone(): void {
      this.freezoneHidden = !this.freezoneHidden;
      // console.log('hideZone', this.freezoneHidden);
      WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.FORM_ZONE_UPDATE, {data: this.data, value: this.freezoneHidden}));
    }  

  /* ##############################################################################
          gestion de la liste de valeurs
     ############################################################################## */

  /**
   * gestion des listes de valeur
   * @param pEvent click
   */
  public showListPop(e: any): void {
     let title = this.componentlabel;

     let datas: PivotCellEditPopData = { 
      kind: WIDGET_GLOBAL_KIND.BASELINE,
      title, 
      label: null, 
      value: this.rawValue, // realValue, //
      column: null,
      fkd: this.fkd, 
      line: this.clone, 
      pack: [this.clone], 
      widget: this.widget, 
      pointer: e as PointerEvent,
      callback: this.backFromListPop.bind(this)};

    /** ouverture de la pop d'édition en masse */
    // dispatch de l'event, sert possiblement pour sélection rapide sur le master, synchro des esclaves
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.SHOWPOP, datas));
  }

  /**
   * callBack de retour de la popUp de saisie de liste
   * @param data PivotCellEditPopData, avec UpdateRequest
   */
  public backFromListPop(data: PivotCellEditPopData): void {
    this.rawValue = data.updates?.value;
    //console.log('back frombackFromListPop', data, this.rawValue);
    WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoList, null));
    this.feed();
  }

  /* ##############################################################################
          gestion des seuils
     ############################################################################## */

  /**
   * gestion des seuils
   * @param pEvent click
   */
  public showThresholdPop(e: any): void {
    let title = this.componentlabel;

     let datas: PivotCellEditPopData = { 
      kind: WIDGET_GLOBAL_KIND.BASELINE,
      title, 
      label: null, 
      value: this.rawValue, // realValue, //
      column: null,
      fkd: this.fkd, 
      line: this.clone, 
      pack: [this.clone], 
      widget: this.widget, 
      settings: this.fkd.measure?.settings,
      pointer: e as PointerEvent,
      callback: this.backFromThresholdPop.bind(this)};


    /** ouverture de la pop d'édition en masse */
    // dispatch de l'event, sert possiblement pour sélection rapide sur le master, synchro des esclaves
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.SHOWPOP, datas));
  }

  /**
   * callBack de retour de la popUp de saisie de liste
   * @param data PivotCellEditPopData, avec UpdateRequest
   */
  public backFromThresholdPop(data: PivotCellEditPopData): void {
    // this.rawValue = data.updates?.value;
    // console.log('back frombackFromListPop', data.updates?.value);
    WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, this.icoThreshold, data.updates?.value));
    this.feed();
  }

  /**
   * chargement de la pièce jointe du workflow
   */
  public loadDropWorkFile(): void {
    AttachmentService.getInstance().filedownloadForWidget(this.workFile);
  }

}
